import useStore from "components/ui/Context"
import { Modal } from "components/ui"

const modalConfig = {
  DEVICE_LIMIT_EXCEED: {
    icon: <img src="/icons/iconArmChair.svg" />,
    title: "Quá 3 thiết bị đăng nhập",
    message: "Vui lòng chọn tiếp để đăng xuất thiết bị cũ nhất",
    buttonText: "Tiếp tục",
    cancelText: "Hủy"
  },
  CHANGE_PASSWORD_SUCCESS: {
    icon: <img src="/icons/iconCreditCard.svg" />,
    title: "Đổi mật khẩu thành công",
    message: "Hãy ghi nhớ mật khẩu của bạn nhé!",
    buttonText: "Tiếp tục đăng nhập"
  },
  CHANGE_PASSWORD_FAIL: {
    icon: <img src="/icons/iconCreditCard.svg" />,
    title: "Đổi mật khẩu thất bại",
    message: "Chưa thể đổi mật khẩu của bạn, vui lòng thử lại sau ít phút",
    buttonText: "Quay lại"
  },
  CREATE_PASSWORD_SUCCESS: {
    icon: <img src="/icons/iconCreditCard.svg" />,
    title: "Tạo mật khẩu thành công",
    message: "Hãy ghi nhớ mật khẩu của bạn nhé!",
    buttonText: "Tiếp tục đăng nhập"
  },
  CREATE_PASSWORD_FAIL: {
    icon: <img src="/icons/iconCreditCard.svg" />,
    title: "Tạo mật khẩu thất bại",
    message: "Chưa thể tạo mật khẩu của bạn, vui lòng thử lại sau ít phút",
    buttonText: "Quay lại"
  },
  CONNECT_PHONE: {
    icon: <img src="/icons/iconArmChair.svg" />,
    title: "Liên kết số điện thoại",
    message: "Thêm số điện thoại để đăng nhập nhanh hơn",
    buttonText: "Liên kết",
    cancelText: "Trải nghiệm trước"
  },
  CONNECT_PHONE_SUCCESS: {
    icon: <img src="/icons/iconPassport.svg" />,
    title: "Hoàn tất liên kết",
    buttonText: "Tiếp tục đăng nhập"
  },
  CONNECT_PHONE_FAIL: {
    icon: <img src="/icons/iconPassport.svg" />,
    title: "Liên kết thất bại",
    message: "Chưa thể liên kết số điện thoại, vui lòng thử lại sau ít phút",
    buttonText: "Quay lại"
  },
  UNFOLLOW_ALL: {
    icon: <img src="/icons/iconColorBox.svg" />,
    title: "Bạn chắc chắn muốn bỏ theo dõi tất cả nội dung?",
    message: "Hành động này sẽ không thể hoàn tác",
    buttonText: "Xác nhận",
    cancelText: "Hủy"
  },
  UNFOLLOW: {
    icon: <img src="/icons/iconColorBox.svg" />,
    title: "Bạn chắc chắn muốn bỏ theo dõi nội dung này?",
    message: "Hành động này sẽ không thể hoàn tác",
    buttonText: "Xác nhận",
    cancelText: "Hủy"
  },
  REMOVE_WATCH_LATER_ALL: {
    icon: <img src="/icons/iconColorBox.svg" />,
    title: "Bạn muốn xóa tất cả nội dung khỏi danh sách xem sau?",
    message: "Hành động này sẽ không thể hoàn tác",
    buttonText: "Xác nhận",
    cancelText: "Hủy"
  },
  REMOVE_WATCH_LATER: {
    icon: <img src="/icons/iconColorBox.svg" />,
    title: "Bạn muốn xóa nội dung này khỏi danh sách xem sau?",
    message: "Hành động này sẽ không thể hoàn tác",
    buttonText: "Xác nhận",
    cancelText: "Hủy"
  },
  LOG_OUT: {
    icon: <img src="/icons/iconLogOut.svg" />,
    title: "Bạn có chắc chắn muốn đăng xuất?",
    message: "Thông tin của bạn sẽ được lưu trữ. Hẹn gặp lại!",
    buttonText: "Đăng xuất",
    cancelText: "Hủy"
  },
  CONFIRM_LOGOUT: {
    icon: <img src="/icons/iconColorBox.svg" />,
    title: "Bạn muốn xóa thiết bị?",
    message: "Hệ thống sẽ đăng xuất tài khoản của bạn khỏi thiết bị đã chọn",
    buttonText: "Đồng ý",
    cancelText: "Hủy"
  }
}

const PopupModal = () => {
  const { modal } = useStore()
  const config = modalConfig[modal.type]

  if (!config) return null

  return (
    <Modal isOpen={true} onCancel={modal.onCancelClick || modal.onButtonClick}>
      <div className="bg-[#1A1A1ADE] text-white pt-5 pb-8 max-sm:px-4 px-10 rounded-2xl">
        <div className="w-[400px] max-sm:w-[326px] max-sm:max-w-full">
          <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <div className="w-20 h-20">{config.icon}</div>
              <div className="flex flex-col gap-1 max-sm:gap-1.5">
                <span className="text-lg leading-6 sm:text-[22px] sm:leading-[30px] font-semibold text-[#FAFAF9]">
                  {config.title}
                </span>
                <p className="text-sm leading-[18px] sm:text-base sm:leading-5 font-normal text-secondary">
                  {config.message || modal.customMessage}
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <button onClick={modal.onButtonClick} className="w-full rounded-xl px-7 py-2.5 gap-2 bg-primary">
                <span className="max-sm:text-sm text-base font-medium text-[#FAFAF9]">{config.buttonText}</span>
              </button>
              {modal.onCancelClick && config.cancelText && (
                <button onClick={modal.onCancelClick} className="w-full rounded-xl px-7 py-2.5 gap-2 bg-[#2E2E2E]">
                  <span className="max-sm:text-sm text-base font-medium text-[#FAFAF9]">{config.cancelText}</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PopupModal
